import { useContext, useState, useRef } from "react";
import "./academy.sass";
import * as React from "react";
import { ConfigContext } from "src/hooks/context/config";
import { UserContext } from "src/hooks/context/userInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSchool } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Spin, Tag } from "antd";

export default function Academy({ title = "" }: { title: string }) {
    const theme = useContext(ConfigContext);
    const user = useContext(UserContext);
    const userName = user.GetNameUser()
    const userUID = user.GetUAID()
    const formRef = useRef(null);
    const { t } = useTranslation('messages');

    if (userName && userUID) return (
        <form action={`${theme.urlAcademy}/local/tokenauth/login.php`} target="_blank" ref={formRef} method="post">
            <input hidden name="username" defaultValue={userName} type="text" />
            <input hidden name="password" defaultValue={userUID} type="text" />
            <button style={{ backgroundColor: "white" }} className="button-academy" type="submit">
                <div className="container-button">
                    <FontAwesomeIcon
                        color="#707070 "
                        className="icons-color-layout icons-color-marging-layout"
                        icon={faSchool}
                    />
                    <p style={{ color: '#707070', margin:0 }}>{title}</p>
                    <Tag color="red">NEW</Tag>
                </div>
            </button>
        </form>
    );

    return <div className="spin-academy">
        <Spin />
        <p className="secondary-links">{t('academy.loading') + ' ' + title}</p>
    </div>;
}
